import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionView } from "./EditionView";
import { EditionViewStore } from "../../store/EditionViewStore";
import { useStore } from "../../../../hooks";

export const EditionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/edition/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "editionData",
              label: rootStore.langStore.groupEditionEditionDataLabel,
            },
            {
              id: "contracts",
              label: rootStore.langStore.groupEditionContractsLabel,
            },
            {
              id: "editionContracts",
              label: rootStore.langStore.groupEditionEditionContractsLabel,
            },
            {
              id: "editionDocumentation",
              label: rootStore.langStore.groupEditionEditionDocumentationLabel,
            },
            {
              id: "editionUserAttachments",
              label:
                rootStore.langStore.groupEditionEditionUserAttachmentsLabel,
            },
            {
              id: "systemDates",
              label: rootStore.langStore.groupEditionSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionView editionViewStore={store} />
      </PageLayout>
    </div>
  );
});
